import { render, staticRenderFns } from "./LeadsDetails.vue?vue&type=template&id=1da0f8fe&scoped=true&"
import script from "./LeadsDetails.vue?vue&type=script&lang=js&"
export * from "./LeadsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da0f8fe",
  null
  
)

export default component.exports